import { render, staticRenderFns } from "./ConfigSyncHtttnAdd.vue?vue&type=template&id=2f9c2464"
import script from "./ConfigSyncHtttnAdd.vue?vue&type=script&lang=js"
export * from "./ConfigSyncHtttnAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports